
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/pro-form-upload.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-pro-form-upload-demo-pro-form-upload"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/pro-form-upload.md?type=demo')
};